<template>
  <b-card class="card" no-body>
    <b-container class="template">
      <b-row class="title-row-margin">
        <b-col cols="6" class="image-col">
          <img class="image" src="/assets/images/classification.svg">
        </b-col>
        <b-col>
          <b-container class="service-container">
            <b-row class="row-title">
              <div class="classification-title">
                Classification
              </div>
            </b-row>
            <b-row class="last-desc-row">
              <div class="desc-header">
                วิเคราะห์และแยกประเภทของข้อความ
              </div>
              <div class="desc-detail">
                ออกเป็นกลุ่มต่างๆ ตามที่กำหนดไว้
              </div>
            </b-row>
            <b-row class="desc-row">
              <div class="desc-header">
                เริ่มด้วยการสร้างกลุ่มของข้อความ (class)
              </div>
              <div class="desc-detail">
                โดยใส่ตัวอย่างของข้อความในแต่ละกลุ่มให้ได้มากที่สุดเท่าที่เป็นไปได้
              </div>
            </b-row>
            <b-row class="desc-row">
              <div class="desc-header">
                เทรนโมเดล classification
              </div>
              <div class="desc-detail">
                เป็นการให้เวลา model เรียนรู้วิธีการแบ่งกลุ่มของข้อความจากตัวอย่างที่ให้มา
              </div>
            </b-row>
            <b-row>
              <div @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'classification_home_page', linkTo: 'classification' })">
                <router-link
                  to="/demo/classification"
                  class="try-button btn btn-primary"
                  exact
                  tag="button"
                >
                  ทดลองใช้งาน
                </router-link>
              </div>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="example-title">
            ตัวอย่างการใช้งาน Classification - แยกประเภทของข้อความ
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col xl="4" lg="4" md="12" sd="12" xs="12">
          <IconCardOver
            icon="/assets/images/food.png"
            title="ข้อความเกี่ยวกับร้านอาหาร"
            :items="['ร้านอาหารราคาไม่แพง','ร้านบุฟเฟ่แถวสีลม','ช่วยแนะนำร้านอาหารริมน้ำบรรยากาศดีๆ']"
          />
        </b-col>
        <b-col xl="4" lg="4" md="12" sd="12" xs="12">
          <IconCardOver
            icon="/assets/images/hotel.png"
            title="ข้อความเกี่ยวกับโรงแรมหรือที่พัก"
            :items="['ช่วยแนะนำที่พักดีๆ ติดริมทะเลหัวหินหน่อย','ที่พักในอุทยานแห่งชาติเขาสก','ที่พักรอบวัดพระแก้วมีที่ไหนบ้าง']"
          />
        </b-col>
        <b-col xl="4" lg="4" md="12" sd="12" xs="12">
          <IconCardOver
            icon="/assets/images/cloudy.png"
            title="ข้อความเกี่ยวกับสภาพอากาศ"
            :items="['สภาพอากาศเป็นยังไงบ้างวันนี้','อาทิตหน้าจะมีฝนตกไหม','รายงานสภาพอากาศกรมอุตุนิยมวิทยา']"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import { BCard, BContainer, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import IconCardOver from './IconCardOver'

export default {
  name: 'ClassificationCard',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    IconCardOver
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    })
  }
}
</script>

<style scoped>

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        width: 100%;
        height: 100%;
        padding: 48px;
    }

    .classification-title {
        color: #48465B;
        opacity: 1;
        font-size: 26px;
        font-weight: 600;
    }

    .row-title {
        margin-bottom: 36px;
    }

    .title-row-margin {
        margin-bottom: 62px;
    }

    .desc-row {
        display: block;
        margin-bottom: 24px;
    }

    .last-desc-row {
        display: block;
        margin-bottom: 36px;
    }

    .desc-header {
        color: #48465B;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .desc-detail {
        color: #9392A0;
        font-size: 14px;
        font-weight: 200;
    }

    .image {
        display: block;
        margin-left: auto;
        margin-right: auto;
        height: 355px;
    }

    .example-title {
        font-weight: 600;
        font-size: 20px;
        color: #48465B;
        text-align: center;
        opacity: 1;
        margin-bottom: 40px;
    }

    @media (max-width: 1379px) {
        .image-col {
            display: none;
        }

        .service-container > * {
            position: relative;
            z-index: 2;
        }

        .service-container::after {
            content: "";
            background-image: url('/assets/images/classification.svg');
            background-repeat: no-repeat;
            background-position: center;
            opacity: 0.3;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>
